export default __webpack_public_path__ + "static/media/landing-background.3ef9a18e.jpg";